import { faArrowLeft } from '@fortawesome/pro-light-svg-icons';

import { StepKeys } from '@/app/(main)/_components/sign-in-modal/_types/header-auth-modal-step-keys.enum';
import { Icon } from '@/components/ui/icon.component';
import { useProgressiveModal } from '@/components/ui/progressive-modal/progressive-modal.hook';
import { SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { PrivacyPolicyContent } from '@/app/(main)/_components/terms-and-policy/privacy-policy-content.client';

export default function PrivacyPolicyStep() {
  const { handleJump: jump } = useProgressiveModal<StepKeys>();

  const handleBack = () => {
    jump({ key: StepKeys.REGISTER, returning: true });
  };

  return (
    <div className="h-full flex flex-col">
      <SheetHeader className="bg-white">
        <div className="flex justify-between gap-3 pb-6 items-center">
          <div className="flex gap-3">
            <div className="flex justify-center w-[30px] h-[30px] self-center">
              <Icon
                icon={faArrowLeft}
                className="cursor-pointer text-gray-500 text-2xl self-center"
                onClick={handleBack}
                data-testid="privacy-icon--back"
              />
            </div>
            <SheetTitle>
              <div className="flex gap-[10px]">
                <span className="font-extrabold text-2xl text-gray-900" data-testid="sheettitle--privacy-policy-step">
                  Política de privacidade
                </span>
              </div>
            </SheetTitle>
          </div>
        </div>
      </SheetHeader>
      <PrivacyPolicyContent />
    </div>
  );
}
